import { dismissAllNiceModals } from 'contexts/ModalProvider/dismissAllNiceModals';

type SessionOverlayTeardownDeps = {
  clearAllToasts: () => void;
  clearAllNotifications?: () => void;
  niceModalContext: Record<string, unknown>;
};

export const teardownSessionOverlays = ({
  clearAllToasts,
  clearAllNotifications,
  niceModalContext,
}: SessionOverlayTeardownDeps) => {
  clearAllToasts();
  dismissAllNiceModals(Object.keys(niceModalContext));
  clearAllNotifications?.();
};
